import { BaseCurrencyInput, Radio } from "@components";
import { useEffect, useState } from "react";

import styles from "@styles/forms-flow/orders.module.scss";

export const OrderCountForm = ({ node, onChange, onSave }) => {
  const [controllerInputs, setControllerInputs] = useState(getInputType(node));

  const [min, setMin] = useState(node.data.min || null);
  const [max, setMax] = useState(node.data.max || null);
  const [exact, setExact] = useState(node.data.exact || null);

  useEffect(() => {
    if (controllerInputs === "exact" && !exact) {
      setExact(0);
    }

    if (controllerInputs === "minimum" && !min) {
      setMin(0);
    }
  }, [controllerInputs]);

  const getFreshNode = () => {
    const dataValue = {
      ...(node?.data || {}),
      min,
      max,
      exact,
    };

    switch (controllerInputs) {
      case "range":
        dataValue.exact = undefined;
        break;
      case "minimum":
        dataValue.exact = undefined;
        dataValue.max = undefined;
        break;
      case "exact":
        dataValue.min = undefined;
        dataValue.max = undefined;
        break;
    }

    return {
      ...node,
      data: dataValue,
    };
  };

  useEffect(() => {
    onChange && onChange(getFreshNode());
  }, [min, max, exact]);

  return (
    <>
      <p className={styles.label}>Defina a quantidade de pedidos</p>

      <Radio
        text="Faixa de quantidade de pedidos"
        family="CustomerOrderCount"
        className="mb-15"
        value="range"
        checked={controllerInputs}
        onChange={() => setControllerInputs("range")}
      />

      {controllerInputs === "range" && (
        <div className="mb-20 d-flex align-center">
          <BaseCurrencyInput
            className="w-100 mr-15"
            value={typeof min == "number" ? min : ""}
            precision={0}
            allowEmpty={true}
            prefix=""
            suffix=" pedidos"
            onChange={(v) => setMin(v)}
          />
          <BaseCurrencyInput
            className="w-100"
            value={max}
            precision={0}
            prefix=""
            suffix=" pedidos"
            onChange={(v) => setMax(v)}
          />
        </div>
      )}

      <Radio
        text="Quantidade miníma de pedidos"
        family="CustomerOrderCount"
        className="mb-15"
        value="minimum"
        checked={controllerInputs}
        onChange={() => setControllerInputs("minimum")}
      />

      {controllerInputs === "minimum" && (
        <BaseCurrencyInput
          className="w-100 mb-20"
          value={min}
          precision={0}
          prefix=""
          suffix=" pedidos"
          onChange={(v) => {
            setMin(v);
          }}
        />
      )}

      <Radio
        text="Quantidade exata de pedidos"
        family="CustomerOrderCount"
        className="mb-15"
        value="exact"
        checked={controllerInputs}
        onChange={() => setControllerInputs("exact")}
      />

      {controllerInputs === "exact" && (
        <BaseCurrencyInput
          className="w-100"
          value={exact}
          precision={0}
          prefix=""
          suffix=" pedidos"
          onChange={(v) => {
            setExact(v);
          }}
        />
      )}
    </>
  );
};

const getInputType = (node) => {
  const { data } = node || {};
  if (data?.exact !== null && data?.exact !== undefined) {
    return "exact";
  } else if (data?.max !== null && data?.max !== undefined) {
    return "range";
  } else if (data?.min !== null && data?.min !== undefined) {
    return "minimum";
  } else {
    return "range";
  }
};
